import { Api } from '@allswipes/client';

/** Клиент кабинета. Ключ токена свой — сессии покупателя и партнёра не смешиваются. */
export const api = new Api(import.meta.env.VITE_API_URL ?? '', 'allswipes-console-token');
